var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tap-top",style:([_vm.display ? { 'display': 'block' } : { 'display': 'none' }]),on:{"click":_vm.executeScroll}},[_c('i',{staticClass:"fas fa-arrow-up"})])
}
var staticRenderFns = []

export { render, staticRenderFns }